import router from "@/router/index";
import _ from 'lodash';

/**
 * 判断当前的对象是否是继承了 common/EntityModule.js/newEntityStoreHelper()
 * @param {String} entity 当前的实体名称
 */
function isInstanceOfCommonEntity(context, entity) {
    // return entityList.includes(entity)
    return context.rootGetters[entity + '/buildByEntityStoreHelper'];
}

const state = {
    loading: false,
    page: 1,
    pageCount: 0,
    //filter: {},

    showNoResultAlert: false,
    showLoadingModal: false,
    showAlertModal: false,
    modalTitle: "Tittle default",
    modalHeader: "Header default",
    modalContent: "Content default",
    headerBgVariant: 'primary',
    bodyBgVariant: 'light',

    userAlertWarningStr: "Warning",
    userAlertWarningVisible: false,
    userAlertSuccessStr: "Success",
    userAlertSuccessVisible: true,
    dismissCountDownSuccess: 5,
    userAlertDangerStr: "Danger",
    userAlertDangerVisible: false,

    showHeader: true,
    showSidebar: true,
    showCollapse: false,
};
const getters = {
    page: state => state.page,
    pageCount: state => state.pageCount
};
const actions = {
    MMFUpdate: function (context, entity) {
        var data = context.rootState[entity]["entity"];
        context.dispatch("api/post", {
                url: context.rootState[entity].baseModuleUrl + "/" + entity + "/update",
                data: data
            }, {
                root: true
            })
            .then(function (entityReturn) { // doing search again
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: "Edit" + " success {id=" + entityReturn.id + "}",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, {
                    root: true
                }).then(function () { // doing search again
                    context.dispatch("base/MMFbackToList", 'rawMaterial', {
                        root: true
                    });
                })
            });
    },
    MMFbackToList(context, module) {
        router.push({
            name: module + 'List'
        });
    },
    MMFSave: function (context, module) {
        var entityAux = context.rootState[module]["entity"];

        //removing empty fileds
        for (var key in entityAux) {
            if (entityAux.hasOwnProperty(key) && (entityAux[key] === "")) delete entityAux[key]
        }

        var strCrud = "Save";
        if (context.rootState[module].crudState == "edit")
            strCrud = "Edit"


        //TODO remove hardcoded for Integration Message Config
        if (entityAux.messageDefinition) {
            var id = entityAux.messageDefinition
            delete entityAux.messageDefinition
            entityAux.messageDefinition = {
                id: id
            }
        }

        if (entityAux.messageDataConversions) {
            entityAux.messageDataConversions.forEach(element => {
                delete element.rowState;
            });
        }

        //支持自定义后端对应的实体类，未定义就取entity，调后端接口时会用到 --2020-10-5 yujiabei
        let backendEntity = context.rootState[module].backendEntity ? context.rootState[module].backendEntity : module


        context.dispatch("api/put", {
                url: context.rootState[module].baseModuleUrl + "/" + backendEntity,
                entity: entityAux,
                module: module
            }, {
                root: true
            })
            .then(function (entityReturn) { // doing search again
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: strCrud + " success {id=" + entityReturn.id + "}",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, {
                    root: true
                }).then(function () { // doing search again
                    //获取returnUrl
                    let returnUrl = context.rootState[module].editReturnUrl
                    let returnPathType = context.rootState[module].editReturnPathType
                    //如果有，就返回到returnUrl
                    if (returnUrl && returnUrl !== "") {
                        router.push({
                            path: returnUrl,
                            query: {
                                pathType: returnPathType ? returnPathType : 'list'
                            }
                        });
                        //returnUrl是一次性的，使用过后要清除掉
                        context.commit(module + "/setEditReturnUrl", "", {
                            root: true
                        })
                        context.commit(module + "/setEditReturnPathType", "", {
                            root: true
                        })
                    }
                    //没有，就返回List
                    else {
                        context.dispatch("base/MMFbackToList", module, {
                                root: true
                            })
                            .then(function () {
                                context.dispatch("base/MMFLoadRows", module, {
                                    root: true
                                });
                            });
                    }
                })
            });
    },
    MMFSaveInline: function (context, module) {
        var entityAux = context.rootState[module]["entity"];
        //removing empty fileds
        for (var key in entityAux) {
            if (entityAux.hasOwnProperty(key) && entityAux[key] === "") delete entityAux[key]
        }

        var strCrud = "Save";
        if (context.rootState[module].crudState == "edit")
            strCrud = "Edit"

        //支持自定义后端对应的实体类，未定义就取entity，调后端接口时会用到 --2020-10-5 yujiabei
        let backendEntity = context.rootState[module].backendEntity ? context.rootState[module].backendEntity : module
        return context.dispatch("api/put", {
                url: context.rootState[module].baseModuleUrl + "/" + backendEntity,
                entity: entityAux,
                module: module
            }, {
                root: true
            })
            .then(function (entityReturn) { // doing search again
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: strCrud + " success {id=" + entityReturn.id + "}",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, {
                    root: true
                })
            })
        // .then(function () {
        //     context.dispatch("base/MMFLoadRows", module, {root: true});
        // });
    },
    MMFDownloadLog: function (context, id) {
        var urlRep = process.env.VUE_APP_ADM_API_URL + "adm-service/adm/threadHistory/" + id + "/downloadLog";
        context.dispatch("api/postReportDownload", {
                url: urlRep,
                data: null
            }, {
                root: true
            })
            .then(data => {
                if (!data || data.size == 0) {
                    context.dispatch("base/showDanger", {
                        userAlertDangerStr: "No report with this fields",
                        userAlertDangerVisible: false,
                    }, {
                        root: true
                    });
                    return;
                }

                var blob = new Blob([data]);
                var link = document.createElement('a');
                link.style.display = 'none'
                link.href = window.URL.createObjectURL(blob);
                link.download = "ThreadLog-" + (new Date().getTime()) + "." + id + ".txt";
                link.click();
                link.remove();
            });
    },
    MMFNew(context, module) {
        router.push({
            name: module + 'Edit'
        });
        context.commit(module + "/" + "setNewEntity", {}, {
            root: true
        });
        context.commit(module + "/" + "setCrudState", 'new', {
            root: true
        });
    },
    MMFEdit(context, module) {
        var entity = _.cloneDeep(context.rootState[module]["entity"]);

        context.commit(module + "/" + "setEntity", entity, {
            root: true
        });
        context.commit(module + "/" + "setCrudState", 'edit', {
            root: true
        });
        router.push({
            name: module + 'Edit'
        });
    },
    MMFDisplay(context, module) {
        var entity = context.rootState[module]["entity"];

        context.commit(module + "/" + "setEntity", entity, {
            root: true
        });
        context.commit(module + "/" + "setCrudState", 'display', {
            root: true
        });
        router.push({
            name: module + 'Display'
        });
    },
    MMFDelete(context, module) {
        var checkedItems = context.rootState[module]["checkedItems"];
        if (checkedItems) {
            var params = 'id=' + checkedItems.join(',');

            // for (let i = 0; i < checkedItems.length; i++) {
            //     params += "&id=" + checkedItems[i];
            // }
        }
        //支持自定义后端对应的实体类，未定义就取entity，调后端接口时会用到 --2020-10-5 yujiabei
        let backendEntity = context.rootState[module].backendEntity ? context.rootState[module].backendEntity : module
        context.dispatch("api/delete", {
                url: context.rootState[module].baseModuleUrl + ("/" + backendEntity + "?" + params)
            }, {
                root: true
            })
            .then(function () { // doing search again
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: "Deleted!",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, {
                    root: true
                }).then(function () { // doing search again
                    context.dispatch("base/MMFLoadRows", module, {
                        root: true
                    });
                })
            });
    },
    //add in 2019-10-9 by yujiabei
    MMFDeleteInline(context, data) {
        //支持自定义后端对应的实体类，未定义就取entity，调后端接口时会用到 --2020-10-5 yujiabei
        let backendEntity = context.rootState[data.entity].backendEntity ? context.rootState[data.entity].backendEntity : data.entity
        context.dispatch("api/delete", {
                url: context.rootState[data.entity].baseModuleUrl + ("/" + backendEntity + "?id=" + data.id)
            }, {
                root: true
            })
            .then(function () { // doing search again
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: "Deleted!",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, {
                    root: true
                }).then(function () { // doing search again
                    context.dispatch("base/MMFLoadRows", data.entity, {
                        root: true
                    });
                })
            });
    },
    MMFselectRow(context, {
        item,
        module
    }) {
        var itens = context.rootState[module].checkedItems.slice();
        var rows = context.rootState[module].rows.slice();
        var indexA = itens.indexOf(item.id);

        if (indexA > -1) { // desselecting
            itens.splice(indexA, 1);
            // 备选项中的最后一个元素
            if (itens.length) { // 如果还有备选元素
                const lastId = itens[itens.length - 1];
                item = rows.filter(r => r.id === lastId)[0] || {}
            } else {
                item = {}
            }
        } else { // selecting
            itens.push(item.id)
        }
        context.commit(module + "/" + "setEntity", item, {
            root: true
        });
        context.commit(module + "/" + "setCheckedItems", itens, {
            root: true
        });
    },
    MMFClearFilter(context, entity) {
        //TODO find a better way to cleanup the filter
        if (isInstanceOfCommonEntity(context, entity)) {
            context.commit(entity + "/setShowNoResultAlert", false, {
                root: true
            });
        }
        context.commit(entity + "/setCheckedItems", [], {
            root: true
        });
        context.commit(entity + "/setClearFilter", undefined, {
            root: true
        });
        context.commit(entity + "/setRows", [], {
            root: true
        });
    },
    MMFExport(context, {
        entity,
        exportParam
    }) { // 旧版本的 MMFExport
        // return context.dispatch(entity + '/searchResultExport', entity, { root: true })

        // 新版写法
        let cloneFilter = context.rootState[entity].fixedFilter;
        for (let key in cloneFilter)
            if (cloneFilter.hasOwnProperty(key) && cloneFilter[key] === "") delete cloneFilter[key]
        const urlRep = process.env.VUE_APP_REPORT_API_URL + "report-service/mmf/report/dispatcher/";
        const url = urlRep + 'asynchronous';
        const data = {
            requestUrl: context.rootState[entity].baseModuleUrl + "/" + entity + "/findByFilter",
            requestParam: Object.assign({}, cloneFilter, exportParam)
        };
        context.dispatch("api/post", {
            url,
            data
        }, {
            root: true
        })
    },
    MMFLoadRows(context, entity) {
        if (isInstanceOfCommonEntity(context, entity)) {
            context.commit(entity + "/setCurrentPage", 1, {
                root: true
            });
            context.commit(entity + "/setFixedFilter", {}, {
                root: true
            });
            context.commit(entity + "/setCheckChangesOnLoad", true, {
                root: true
            });
            //add on 2019-10-9 by yujiabei
            //暂时先以这种方式阻止一次编辑多行，因为每次刷新后，现有的编辑行就失效了。所以干脆清除掉。
            context.commit(entity + "/clearEditingRows", {}, {
                root: true
            });
        }
        return context.dispatch("base/MMFLoadRowsSearch", entity, {
            root: true
        });
    },
    MMFLoadRowsSearch(context, entity) {
        //支持自定义后端对应的实体类，未定义就取entity，调后端接口时会用到 --2020-10-5 yujiabei
        let backendEntity = context.rootState[entity].backendEntity ? context.rootState[entity].backendEntity : entity
        return new Promise((resolve) => {
            // cloning filter to discard empty fields
            // filter is defined in each entity
            context.commit(entity + "/setCheckedItems", [], {
                root: true
            });
            var cloneFilter = Object.assign({}, context.rootState[entity].fixedFilter)
            context.commit(entity + "/" + "setCrudState", 'list', {
                root: true
            });
            //removing empty fileds
            for (var key in cloneFilter)
                if (cloneFilter.hasOwnProperty(key) && cloneFilter[key] === "") delete cloneFilter[key]
            context.dispatch("api/post", {
                    url: context.rootState[entity].baseModuleUrl + "/" + backendEntity + "/findByFilter",
                    data: cloneFilter
                }, {
                    root: true
                })
                .then(response => {
                    //setting the values
                    if (isInstanceOfCommonEntity(context, entity)) {
                        if (response.data && response.data.list && response.data.list.length > 0) {
                            context.commit(entity + "/setRows", response.data.list, {
                                root: true
                            });
                            context.commit(entity + "/setShowNoResultAlert", false, {
                                root: true
                            });
                            context.commit(entity + "/setPagination", response.data.pagination, {
                                root: true
                            });
                            context.dispatch(entity + '/showItemLimitationAlert', entity, {
                                root: true
                            })
                        } else {
                            context.commit(entity + "/setShowNoResultAlert", true, {
                                root: true
                            });
                        }
                    } else {
                        context.commit(entity + "/setRows", response.data, {
                            root: true
                        });
                    }
                    context.dispatch(entity + '/afterLoadRowsTrigger', response.data.list, {
                        root: true
                    })
                    resolve();
                }).catch(function () {
                    context.commit("base/setShowLoadingModal", false, {
                        root: true
                    });
                });
        })
    },
    showLoading(context) {
        context.commit("base/setShowLoadingModal", true, {
            root: true
        });
    },
    hideLoading(context) {
        context.commit("base/setShowLoadingModal", false, {
            root: true
        });
    },
    showAlert(context, {
        showAlertModal,
        modalTitle,
        modalHeader,
        modalContent,
        headerBgVariant
    }) {
        if (modalTitle)
            context.commit("base/setModalTitle", modalTitle, {
                root: true
            });

        if (modalHeader)
            context.commit("base/setModalHeader", modalHeader, {
                root: true
            });

        if (headerBgVariant)
            context.commit("base/setHeaderBgVariant", headerBgVariant, {
                root: true
            });

        if (modalContent)
            context.commit("base/setModalContent", modalContent, {
                root: true
            });

        if (modalHeader)
            context.commit("base/setModalHeader", modalHeader, {
                root: true
            });

        context.commit("base/setShowAlertModal", showAlertModal ? showAlertModal : true, {
            root: true
        });
    },
    showSuccess(context, {
        userAlertSuccessStr,
        dismissCountDown,
        userAlertSuccessVisible
    }) {
        context.commit("base/setUserAlertSuccessStr",
            userAlertSuccessStr, {
                root: true
            });

        context.commit("base/setDismissCountDownSuccess",
            dismissCountDown ? dismissCountDown : 5, {
                root: true
            });

        context.commit("base/setUserAlertSuccessVisible",
            userAlertSuccessVisible, {
                root: true
            });
    },
    showWarning(context, {
        userAlertWarningStr,
        userAlertWarningVisible
    }) {
        context.commit("base/setUserAlertWarningStr",
            userAlertWarningStr, {
                root: true
            });

        context.commit("base/setUserAlertWarningVisible",
            userAlertWarningVisible, {
                root: true
            });
    },
    showDanger(context, {
        userAlertDangerStr,
        userAlertDangerVisible
    }) {
        context.commit("base/setUserAlertDangerStr",
            userAlertDangerStr, {
                root: true
            });

        context.commit("base/setUserAlertDangerVisible",
            userAlertDangerVisible, {
                root: true
            });
    }
};
const mutations = {
    //Controls the "Loading" state of the application,
    //e.g. when retrieving data from an API
    setLoading(state, loading) {
        state.loading = loading;
    },
    setPage(state, page) {
        state.page = page
    },
    setShowLoadingModal(state, showLoadingModal) {
        state.showLoadingModal = showLoadingModal;
    },
    setShowAlertModal(state, showAlertModal) {
        state.showAlertModal = showAlertModal;
    },
    setModalTitle(state, modalTitle) {
        state.modalTitle = modalTitle;
    },
    setModalHeader(state, modalHeader) {
        state.modalHeader = modalHeader;
    },
    setModalContent(state, modalContent) {
        state.modalContent = modalContent;
    },
    setUserAlertWarningStr(state, userAlertWarningStr) {
        state.userAlertWarningStr = userAlertWarningStr;
    },
    setHeaderBgVariant(state, headerBgVariant) {
        state.headerBgVariant = headerBgVariant;
    },
    setUserAlertWarningVisible(state, userAlertWarningVisible) {
        state.userAlertWarningVisible = userAlertWarningVisible;
    },
    setUserAlertSuccessStr(state, userAlertSuccessStr) {
        state.userAlertSuccessStr = userAlertSuccessStr;
    },
    setUserAlertSuccessVisible(state, userAlertSuccessVisible) {
        state.userAlertSuccessVisible = userAlertSuccessVisible;
    },
    setUserAlertDangerStr(state, userAlertDangerStr) {
        state.userAlertDangerStr = userAlertDangerStr;
    },
    setUserAlertDangerVisible(state, userAlertDangerVisible) {
        state.userAlertDangerVisible = userAlertDangerVisible;
    },
    setDismissCountDownSuccess(state, dismissCountDownSuccess) {
        state.dismissCountDownSuccess = dismissCountDownSuccess;
    },
    setShowHeader(state, showHeader) {
        state.showHeader = showHeader;
    },
    setShowSidebar(state, showSidebar) {
        state.showSidebar = showSidebar;
    },
    setShowCollapse(state, showCollapse) {
        state.showCollapse = showCollapse;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
